(function ($) {

    function addClassScroll(){
        $(window).scroll(function() {    
            var scroll = $(window).scrollTop();
            if (scroll >= 300) {
                $("body").addClass("scroll-active");
            } else {
                $("body").removeClass("scroll-active");
            }
        });
    }

    function mobileMenu(){		
		var scroll = 0;
        $('.js-mobile-nav-toggle').click(function (e) {
            if($(this).hasClass('mobile-nav--close')){
                if($('body').hasClass('scroll-active')){
                    $('body').addClass('menu-open-scroll');
                    /*$('html, body').animate({
                        scrollTop: $('#shopify-section-header').offset().top
                    }, 'fast');*/
                } else {
                    $('body').removeClass('menu-open-scroll');
                }
                $('body').addClass('menu-open');
				scroll = $(window).scrollTop();
            } else {
                $('body').removeClass('menu-open');
            }
			$('html, body').animate({
				scrollTop: $('#shopify-section-header').offset().top + scroll
			}, 'fast');
        });
    }

    function slickSliders() {
        $(".section__hero-slider .section__inner").slick({
            infinite: true,
            slidesToShow: 1,
            lazyLoad: 'progressive',
            arrows: false,
            dots: true,
            autoplay: false,
            speed: 1000,
            easing: 'swing'
        });
        if ($(window).width() < 733) {
            $(".index-section.section__featured-collections .grid").slick({
                centerMode: true,
                centerPadding: '60px',
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                lazyLoad: 'progressive',
                arrows: true,
                autoplay: false,
                speed: 2000,
                autoplaySpeed: 3000,
                useTransform: true,
                adaptiveHeight: true,
                dots: true,
                prevArrow: $('.slick-collection-prev'),
                nextArrow: $('.slick-collection-next')
            });
        }
        $(".section__content-slider .content__slider-wrapper").slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            lazyLoad: 'progressive',
            arrows: true,
            autoplay: false,
            speed: 2000,
            autoplaySpeed: 3000,
            useTransform: true,
            adaptiveHeight: true,
            prevArrow: $('.slick-content-prev'),
            nextArrow: $('.slick-content-next')
        });
        $(".section__most-viewed-products-carousel .product__list").slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            lazyLoad: 'progressive',
            arrows: true,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 3000,
            useTransform: true,
            adaptiveHeight: true,
            prevArrow: $('.slick-product-view-prev'),
            nextArrow: $('.slick-product-view-next'),
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: 4
                    }
                },
                {
                  breakpoint: 1025,
                  settings: {
                    slidesToShow: 3
                  }
                },
                {
                    breakpoint: 980,
                    settings: {
                      slidesToShow: 2
                    }
                },
                {
                    breakpoint: 750,
                    settings: {
                      slidesToShow: 1
                    }
                }
            ]
        });
        var maxHeight = 0;
        $(".product__list .product__item > div").each(function() {
            if ($(this).outerHeight() > maxHeight) {
                maxHeight = $(this).outerHeight() - 50;
            }
        });
        //$(".product__list .product__item > div").height(maxHeight);
        $(".section__services-list .services__slider").slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: 'progressive',
            arrows: false,
            autoplay: false,
            speed: 500,
            autoplaySpeed: 3000,
            useTransform: true,
            adaptiveHeight: true,
            fade: true,
            draggable: false,
            asNavFor: '.services__navigation'
        });
        $(".section__services-list .services__navigation").slick({
            infinite: true,
            slidesToShow: 7,
            slidesToScroll: 1,
            infinite: true,
            lazyLoad: 'progressive',
            arrows: true,
            autoplay: false,
            speed: 500,
            autoplaySpeed: 3000,
            useTransform: true,
            adaptiveHeight: true,
            draggable: false,
            prevArrow: $('.slick-collection-prev'),
            nextArrow: $('.slick-collection-next'),
            asNavFor: '.services__slider',
            focusOnSelect: true,
            responsive: [
                {
                  breakpoint: 1025,
                  settings: {
                    slidesToShow: 4
                  }
                },
                {
                    breakpoint: 750,
                    settings: {
                      slidesToShow: 2
                    }
                }
            ]
        });
        if ($(window).width() > 1023) {
            $('.services__navigation .slick-slide').mouseover(function(){
                $(this).click();
            })
        }
        $(".related-products.section__featured-products-carousel .product__list").slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            lazyLoad: 'progressive',
            arrows: true,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 3000,
            useTransform: true,
            adaptiveHeight: true,
            prevArrow: $('.slick-product-prev'),
            nextArrow: $('.slick-product-next'),
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: 4
                    }
                },
                {
                  breakpoint: 1025,
                  settings: {
                    slidesToShow: 3
                  }
                },
                {
                    breakpoint: 980,
                    settings: {
                      slidesToShow: 2
                    }
                },
                {
                    breakpoint: 750,
                    settings: {
                      slidesToShow: 1
                    }
                }
            ]
        });
        setTimeout(function() {
            if ( $('.related-products .product__list .slick-track').children().length > 0 ) {} else {
                $('.related-products .slick-nav').addClass('hide');
            }
        }, 1000);
    }

    function featuredProductsSlick(){
        $(".section__featured-products-carousel .product__list.active").slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            lazyLoad: 'progressive',
            arrows: true,
            autoplay: true,
            speed: 500,
            autoplaySpeed: 3000,
            useTransform: true,
            adaptiveHeight: true,
            prevArrow: $('.slick-product-prev'),
            nextArrow: $('.slick-product-next'),
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: 4
                    }
                },
                {
                  breakpoint: 1025,
                  settings: {
                    slidesToShow: 3
                  }
                },
                {
                    breakpoint: 980,
                    settings: {
                      slidesToShow: 2
                    }
                },
                {
                    breakpoint: 750,
                    settings: "unslick"
                    // settings: {
                    //   slidesToShow: 1
                    // }
                }
            ]
        });
        var maxHeight = 0;
        $(".product__list .product__item > div").each(function() {
            if ($(this).outerHeight() > maxHeight) {
                maxHeight = $(this).outerHeight() - 50;
            }
        });
        //$(".product__list .product__item > div").height(maxHeight);
    }

    function addToCart(){
        $('.product__item .btn__add-to-cart').click(function (e) {
            e.preventDefault();
            var quantity = 1;
            var id= $(this).closest('.product__item').attr('data-product-id');
            var productItem = $(this).closest('.product__item').children('div');
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: {id:id,quantity:quantity},
                success: function(){
                    $(productItem).append('<div class="product__added">Added to cart</div>');
                    setTimeout(function() {
                        $.getJSON('/cart.js', function(cart) {
                          $('#CartCount span[data-cart-count]').html(cart.item_count);
                          $('#CartCount').removeClass('hide');
                        })
                    }, 1000);
                }
            });
        });
    }

    function categoryFilter(){
        $('#featured-category-filter').on('change', function() {
            var activeCat = $(this).val();
            $(".section__featured-products-carousel .product__list.active").slick('unslick');
            $('.section__featured-products-carousel .product__list').removeClass('active');
            $('.section__featured-products-carousel .product__list[data-collection="' + activeCat + '"]').addClass('active');
            $('.section__featured-products-carousel .slick-nav').removeClass('active');
            $('.section__featured-products-carousel .slick-nav[data-collection="' + activeCat + '"]').addClass('active');
            featuredProductsSlick();
        });
    }

    function locationTab(){
        $('.location-state a').click(function (e) {
            e.preventDefault();
            var locationAttr = $(this).closest('.location-state').attr('data-location');
            $('.location-map').removeClass('active');
            $('.location-map[data-location="'+ locationAttr +'"]').addClass('active');
            $('.location-state').removeClass('active');
            $('.location-state[data-location="'+ locationAttr +'"]').addClass('active');
            $('.opening-hours').removeClass('active');
            $('.opening-hours[data-location="'+ locationAttr +'"]').addClass('active');
        });
        $('.cpap__clinic-state a').click(function (e) {
            e.preventDefault();
            var locationAttr = $(this).closest('.cpap__clinic-state').attr('data-location');
            $('.cpap__clinic').removeClass('active');
            $('.cpap__clinic[data-location="'+ locationAttr +'"]').addClass('active');
            $('.cpap__clinic-state').removeClass('active');
            $('.cpap__clinic-state[data-location="'+ locationAttr +'"]').addClass('active');
        });
    }

    function footerNewsletter(){
        if( $('.block__newsletter .input-error-message, .block__newsletter .form-message').length ){
            setTimeout(function() {
                $('html, body').animate({
                    scrollTop: $('.section__locations-newsletter').offset().top
                }, 'slow');
            }, 2000);
        }
    }

    function faqs(){
        $('.faq__nav a').click(function (e) {
            e.preventDefault();
            var currentFaq = $(this).parent().closest('li').attr('data-faq');
            $('.faq__nav li').removeClass('active');
            $('.faq__nav li[data-faq="'+ currentFaq +'"]').addClass('active');
            $('.faq__content .faq__item').removeClass('active');
            $('.faq__content .faq__item[data-faq="'+ currentFaq +'"]').addClass('active');
        });
    }

    function hideDuplicateTags(){
        var arr = [];
        $(".blog-tags span").each(function(){
            $(this).children("a[class^='tag']").each(function(){
                if(arr.indexOf($(this).attr("class"))>(-1)){
                    $(this).hide();
                }
                else{
                    arr.push($(this).attr("class"));
                }
            });
        });
    }

    function collectionSidebar(){
        if($('.collection-active').hasClass('collection-child-active')){
            $('.child li').removeClass('collection-active');
            $('.collection-child-active').addClass('collection-active');
        }
        if($('.sidebar-block .child li').hasClass('collection-child-active')){
            $('.collection-child-active').closest('ul.child').parent().addClass('collection-active');
        }
        $('.template-collection .grid__sidebar .sidebar-block .link-brands > a').click(function(e) {
            e.preventDefault();
            $(this).closest('li').toggleClass('collection-active');
        });
        $('.template-collection .grid__sidebar .sidebar-block .h4').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('filter-active');
            $(this).next().toggleClass('filter-active');
        });
    }

    function shareBookmarkPage(){
        $('.social-bookmark a').click(function() {
            if (window.sidebar && window.sidebar.addPanel) { // Mozilla Firefox Bookmark
              window.sidebar.addPanel(document.title, window.location.href, '');
            } else if (window.external && ('AddFavorite' in window.external)) { // IE Favorite
              window.external.AddFavorite(location.href, document.title);
            } else if (window.opera && window.print) { // Opera Hotlist
              this.title = document.title;
              return true;
            } else { // webkit - safari/chrome
              alert('Press ' + (navigator.userAgent.toLowerCase().indexOf('mac') != -1 ? 'Command/Cmd' : 'CTRL') + ' + D to bookmark this page.');
            }
        });
        $('.social-share a').click(function(e) {
            e.preventDefault();
            $(".social-icons").toggleClass("active");
        });
    }

    function quantityButtons(){
        jQuery('<div class="quantity-nav"><div class="quantity-button quantity-down">-</div><div class="quantity-button quantity-up">+</div></div>').insertAfter('.product-form__input--quantity');
        jQuery('.product-form__item').each(function() {
            var spinner = jQuery(this),
                input = spinner.find('input[type="number"]'),
                btnUp = spinner.find('.quantity-up'),
                btnDown = spinner.find('.quantity-down'),
                min = input.attr('min'),
                max = input.attr('max');

            btnUp.click(function() {
                var oldValue = parseFloat(input.val());
                if (oldValue >= max) {
                var newVal = oldValue;
                } else {
                var newVal = oldValue + 1;
                }
                spinner.find("input").val(newVal);
                spinner.find("input").trigger("change");
            });

            btnDown.click(function() {
                var oldValue = parseFloat(input.val());
                if (oldValue <= min) {
                var newVal = oldValue;
                } else {
                var newVal = oldValue - 1;
                }
                spinner.find("input").val(newVal);
                spinner.find("input").trigger("change");
            });
        });
    }

    function productThumbnailBullets(){
        var activeThumb = $('.product-single__thumbnail.active-thumb').parent().index();
        $('.thumbnail-bullets li[data-bullet="'+ activeThumb +'"]').addClass('active');
        $('.thumbnail-bullets li').click(function(e) {
            var clickedBullet = $(this).attr('data-bullet');
            //$('.product-single__thumbnails-item[data-slider-slide-index="'+ clickedBullet +'"] a')[0].click();
            $('.product-single__thumbnails-item').eq(clickedBullet).children('a')[0].click();
            $('.thumbnail-bullets li').removeClass('active');
            $('.thumbnail-bullets li[data-bullet="'+ clickedBullet +'"]').addClass('active');
        });
        $('.product-single__thumbnail').click(function(e) {
            var clickedThumb = $(this).parent().index();
            $('.thumbnail-bullets li').removeClass('active');
            $('.thumbnail-bullets li[data-bullet="'+ clickedThumb +'"]').addClass('active');
        });
    }

    function productTabs(){
        $('.template-product .tabpanel__panel').each(function(i, el) {
            if ($(this).height() > 360) {
                $(this).addClass('tabpanel__min');
            }
        });
        $('.panel-expand').click(function (e) {
            e.preventDefault();
            $(this).closest('.tabpanel__panel').removeClass('tabpanel__min');
        });
    }

    function productPriceDecimal(){
        $('.product__price .price__current').each(function(i, obj) {
            $(this).html(function(i, html){
                return html.replace( /(\.\d+)$/, '<span class="decimals">$1</span>')
            });
        });
    }

    function aboutClinic(){
        var maxHeight = 0;
        $(".clinic-content .cpap__clinic").each(function() {
            if ($(this).outerHeight() > maxHeight) {
                maxHeight = $(this).outerHeight();
            }
        });
        $(".clinic-content .cpap__clinic").height(maxHeight);
    }

    function contactForm(){
        $('#ContactForm-book-consultation').change(function() {
            if(this.checked) $('.field__locations').show();
            else $('.field__locations').hide();
        });
    }

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    function addToCartLink(){
        function replaceLink(){
            var currentLink = $('.btn__quick-cart').attr('href');
            var variationID = getUrlParameter('variant');
            var newLink = currentLink.replace(/(id=).*?(&)/,'$1' + variationID + '$2');
            $('.btn__quick-cart').attr('href', newLink);
        }

        if ( getUrlParameter('variant') ){
            replaceLink();
        }

        $('.product-form .single-option-selector').change(function(){
            replaceLink();
        });
    }
	
	function fixDebutForgotPassword(){
		$('#RecoverPassword').click(function(e) {
			e.preventDefault();
			$('#RecoverPasswordForm').removeClass('hide');
			$('#CustomerLoginForm').addClass('hide');
			
		});
		$('#HideRecoverPasswordLink').click(function(e) {
			e.preventDefault();
			$('#RecoverPasswordForm').addClass('hide');
			$('#CustomerLoginForm').removeClass('hide');
			
		});
		if($('.reset-password-success').length){
			$('#ResetSuccess').removeClass('hide');
		}
	}

    function fixSearchPopup(){
        $('#SearchDrawer .search-bar__close').click(function(e) {
            $('.mobile-nav-wrapper').removeClass('is-transitioning');
        });
    }


    $(document).ready(function() {
        addClassScroll();
        mobileMenu();
        slickSliders();
        featuredProductsSlick();
        addToCart();
        categoryFilter();
        locationTab();
        footerNewsletter();
        faqs();
        hideDuplicateTags();
        collectionSidebar();
        shareBookmarkPage();
        quantityButtons();
        productThumbnailBullets();
        productTabs();
        productPriceDecimal();
        aboutClinic();
        contactForm();
        addToCartLink();
		//fixDebutForgotPassword();
        fixSearchPopup();
    });

} (window.jQuery || window.$) );

 function showwebform(arg,div)
{
	$("#popup1.overlay").toggleClass("active");
}